<!------------- ETC comments threads pops up ------------------>
	<div class="reject_popup" *ngIf="thread_msg !== null">
		<div class="reject_popup_wrapper">
			<div class="reject_popup_header">
				<h3>{{"RejectReason" | translate}}</h3><button class="pop_close" (click)="threadClose()"><i class="bi bi-x"></i></button>
			</div>
			<div class="reject_popup_body" *ngIf="thread_msg.length > 0; else noMsg">
				<ul>
					<li *ngFor="let msg of thread_msg" class="client asso">
						<h5>{{msg.modifyUserName}}<span>{{formatDateTime(msg.modifyDate)}}</span></h5>
						<p>{{msg.modifyComment}}</p>
					</li>
				</ul>
			</div>
			<ng-template #noMsg>
				<div class="reject_popup_body">
					<p>{{'NoComments' | translate}}</p>
				</div>

			</ng-template>
		
		</div>
		
	</div>

<!---------------------------- END ----------------------------->


<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row">
		<div class="select_month col-auto">
			<h2><label for="select_year_month">{{"SELECTMONTH" | translate}}</label> </h2>
			<select 
			class="form-select" 
			aria-label="Month selection"
			[(ngModel)]="selectedTimesheetId"
			(change)="fncCng($event)">
				<option *ngFor="let date of monthDropdown" [value]="date.timesheetId" [title]="getOptionTitle(date)">
					{{(lang == 'en') ? date.eNdate : date.jPdate}} ({{date.companyName}})
				</option>
			</select>
		</div>
		<!-- {{userCode}} -->
		<div class="summary col-auto">
			<h2>{{"MonthlySummary" | translate}} :</h2>
			<ul>
				<li>
					<p><strong>{{"REGULAR" | translate}} - </strong> <span>{{timeSheetTopPannel?.regular}}</span></p>
				</li>
				<li>
					<p><strong>{{"OVERTIME" | translate}} - </strong> <span>{{timeSheetTopPannel?.overtime}}</span></p>
				</li>
				<li>
					<p><strong>{{"MIDNIGHT" | translate}} - </strong> <span>{{timeSheetTopPannel?.midnightOvertime}}</span></p>
				</li>
				<li>
					<p><strong>{{"TOTAL" | translate}} - </strong> <span>{{timeSheetTopPannel?.total}}</span></p>
				</li>
				<li>
					<p><strong>{{"ATTENDANCE" | translate}} - </strong> <span>{{tsSummary?.attendanceDays}}</span></p>
				</li>
				<li>
					<p><strong>{{"ABSENCE" | translate}} - </strong> <span>{{tsSummary?.absence}}</span></p>
				</li>
				<li>
					<p><strong>{{"PAIDHOLIDAY" | translate}} - </strong> <span>{{tsSummary?.paidHoliday}}</span></p>
				</li>
				<li>
					<p><strong>{{"HOME" | translate}} - </strong> <span>{{tsSummary?.teleWork}}</span></p>
				</li>
			</ul>
		</div>
		</section>
</div>

<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper_timesheet">

	<div class="actio_button_area">
		<div class="asso_name">
			<strong>{{'Associate' | translate}} : </strong>{{timeSheetTopPannel?.userCode}} {{timeSheetTopPannel?.userName}}
		</div>
		<div class="asso_name" style="margin-left: 20px;">
			<strong>{{"CompanyName" | translate}} : </strong>{{timeSheetCmnData?.customerName}}
		</div>

		<button class="butn save_entry btn" (click)="onSave()" [disabled]="archive || !hasCheckedRows">{{'SAVE' | translate}}</button>
		<!--<button class="butn cancel_entry btn">{{"CANCEL" | translate}}</button>-->
		<!--<a class="butn log_entry btn" href="associate-time-log/{{timesheetIdOrg}}/{{userIdOrg}}?from=approver">{{'LOG' | translate}}</a>-->
		<a *ngIf="!embeddedMode"
   			class="butn log_entry btn"
   			[routerLink]="['/associate-time-log', timesheetIdOrg, userIdOrg]"
   			[queryParams]="{ from: 'approver' }">{{'LOG' | translate}}</a>
		<a *ngIf="embeddedMode"
   			class="butn log_entry btn"
   			href="javascript:void(0)"
   			(click)="logClicked.emit()">{{'LOG' | translate}}</a>
		<a class="butn pdf_down btn" href="javascript:void(0)" (click)="dwnPdf(timesheetId)">{{"PDFDWN" | translate}}</a>
		<!--<a *ngIf="!embeddedMode" class="butn go_back btn" href="representative-timesheet/{{timesheetIdOrg}}/{{userIdOrg}}">{{"Back" | translate}}</a>		<a *ngIf="embeddedMode" class="butn go_back btn" href="javascript:void(0)" (click)="backClicked.emit()">{{'Back' | translate}}</a>	</div>-->
        <a *ngIf="!embeddedMode" class="butn go_back btn" href="/representative-timesheet/{{timesheetIdOrg}}/{{userIdOrg}}">{{"Back" | translate}}</a>		<a *ngIf="embeddedMode" class="butn go_back btn" href="javascript:void(0)" (click)="backClicked.emit()">{{'Back' | translate}}</a>	</div>
	<div class="save-toast" *ngIf="showSaveToast">
		<span>{{ "dataSaveSuccesMessage" | translate }}</span>
	</div>
	<div *ngIf="dashboard_msg !== null" class="alert alert-{{msgType}} alert-dismissible" (click)="reset()" role="alert">
            {{ dashboard_msg | translate}}
			  
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" style="float: right; border-radius: 15px; border: none;">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
	<div class="time_sheet_ligend" *ngIf="lang === 'en'">
		<ul>
			<li class="status"><span>{{"STATUS" | translate}}</span></li>
			<li class="nSubmit"><s>{{"Status.N" | translate}}</s><span>{{"Status.NOTSUBMIT" | translate}}</span></li>
			<li class="submit"><s>{{"Status.S" | translate}}</s><span>{{"Status.SUBMIT" | translate}}</span></li>
			<!--<li class="fix"><s>F</s><span>Fix</span></li>-->
			<li class="approve"><s>{{"Status.A" | translate}}</s><span>{{"Status.APPROVE" | translate}}</span></li>
			<li class="reject"><s>{{"Status.R" | translate}}</s><span>{{"Status.REJECT" | translate}}</span></li>
		</ul>
	</div>
	<!--  ############### Data Table Start ################# -->
	<div class="time_sheet_table_wrapper">
		<!-- Table Heading Start -->
		<div class="timeSheet_row_heading timesheet-header">
            <section>
                <article>
                    <div class="tbl_date">{{"DATE" | translate}}</div>
                    <div class="tbl_approve">
                        <label class="switch">
							<input type="checkbox"
							[(ngModel)]="selectAll"
								[ngModelOptions]="{standalone: true}"
							(change)="toggleAllApprovals($event)" [disabled]="archive || hasNoApprovableRows">
							<span class="slider"></span>
						</label>
                        {{"APPROVE" | translate}}
                    </div>
                    <div class="tbl_status">{{"STATUS" | translate}}</div>
                    <div class="tbl_action">{{"REJECT" | translate}}</div>
                	<div class="tbl_start">{{"START" | translate}}</div>
                    <div class="tbl_finish">{{"FINISH" | translate}}</div>
                    <div class="tbl_break">{{"BREAK" | translate}}</div>
                    <div class="tbl_mnBreak">{{"MIDNIGHTBREAK" | translate}}</div>
                    <div class="tbl_note">{{"NOTE" | translate}}</div>
                    <div class="tbl_home">{{"HOME" | translate}}</div>
                    <div class="tbl_exp">{{"EXPENSES" | translate}}</div>
                    <div class="tbl_amtExp">{{"AMOUNTOFEXPENSES" | translate}}</div> 
					<div class="tbl_etc">{{"ETC" | translate}}</div>                   
                </article>
            </section>
        </div>
		<!-- Table Heading End -->
		<!-- Mobile Table Heading Start -->
		<div class="timeSheet_row_heading_mobile timesheet-header">
			<aside>
				<div class="tbl_nav">{{"EXPAND" | translate}}</div>
				<div class="tbl_approve">
					<label class="switch">
						<input type="checkbox"
						[(ngModel)]="selectAll"
						[ngModelOptions]="{standalone: true}"
					(change)="toggleAllApprovals($event)" [disabled]="archive || hasNoApprovableRows">
						<span class="slider"></span>
					</label>
				</div>
				<div class="tbl_date">{{"DATE" | translate}}</div>
				<div class="tbl_status">{{"STATUS" | translate}}</div>
				<div class="tbl_home">{{"HOME" | translate}}</div>
				<div class="tbl_start">{{"START" | translate}}</div>
				<div class="tbl_finish">{{"FINISH" | translate}}</div>
				<div class="tbl_break">{{"BREAK" | translate}}</div>
				<div class="tbl_mnBreak">{{"MIDNIGHTBREAK" | translate}}</div>
			</aside>
		</div>
		<!-- Mobile Table Heading End -->
		<!-- Table Data Start as loop-->
		 <div class="timeSheet_row {{item.statusClass}}" *ngFor="let item of timeSheetData; trackBy: trackByTimesheetLineItemId; let i = index" id="timeSheet_row_{{i}}">
            <section>
                <aside>
                    <div class="tbl_nav"><button class="expand" [class.active]="expandedRowsButton[i]" (click)="toggleBelowRows(i)"></button></div>
                    <div class="tbl_approve">
                        <label class="switch" *ngIf="(item.status == 20)">
							<input type="checkbox"
							[(ngModel)]="item.markedForSubmit"
							[ngModelOptions]="{standalone: true}" class="chkApproveStatus" [disabled]="archive || isRejectEditing" *ngIf="(item.status == 20)" (change)="chkSubmitCnt()"/>
							<span class="slider"></span>
						</label>
                    </div>
					<div class="tbl_date">
						<strong class="{{item.dayWeekShort}} {{item.isHoliday? 'sun':''}}">{{ item.dayWeekDay }} ({{ item.dayWeekKey | translate }})</strong>
					</div>
					<div class="tbl_status">
						<dl><span [ngClass]="{ 'get_comment': (item.status === 30 || item.status === 20) }" (click)="onRejectClick(item)">{{ item.statusKey | translate }}</span></dl>
					</div>
                    <div class="tbl_home">
                        <label class="switch2">
							<input type="checkbox" [(ngModel)]="item.whf" [ngModelOptions]="{standalone: true}" disabled="">
							<span class="slider"></span>
						</label>
                    </div>
					<div class="tbl_start">
						<p>{{item.startTime}}</p>
                    </div>
                    <div class="tbl_finish">
						<p>{{item.endTime}}</p>
                    </div>
                    <div class="tbl_break">
						<p>{{item.breakMinutes}}</p>
                    </div>
                    <div class="tbl_mnBreak">
                        <p>{{item.midnightBreakMinutes}}</p>
                    </div>
                </aside>
                <article [ngClass]="{ 'expanded': expandedRows[i] }">
					<div class="tbl_date">
						<strong class="{{item.dayWeekShort}} {{item.isHoliday? 'sun':''}}">{{ item.dayWeekDay }} ({{ item.dayWeekKey | translate }})</strong>
					</div>
                    <div class="tbl_approve">
						<samp>{{"APPROVE" | translate}}</samp>
                        <label class="switch" *ngIf="(item.status == 20)">
							<input type="checkbox" 
							[(ngModel)]="item.markedForSubmit" 
							[ngModelOptions]="{standalone: true}" class="chkApproveStatus" [disabled]="archive || isRejectEditing" *ngIf="(item.status == 20)" (change)="chkSubmitCnt()"/>
							<span class="slider"></span>
						</label>						
                    </div>
                    <div class="tbl_status">
						<samp>{{"STATUS" | translate}}</samp>
						<dl><span [ngClass]="{ 'get_comment': (item.status === 30 || item.status === 20) }" (click)="onRejectClick(item)">{{ item.statusKey | translate }}</span></dl>
					</div>
                    <div class="tbl_action">
						<samp>{{"REJECT" | translate}}</samp>
                        <div class="reject_save" *ngIf="(item.status == 20)">
                            <label class="switch_radio">
								<input type="checkbox" 
								[(ngModel)]="item.markedForReject" 
								[ngModelOptions]="{standalone: true}" class="chkStatus" (change)="editReject(i)" [disabled]="archive || isRejectEditing"/>
								<span class="slider"></span>
							</label>
						</div>    
                    </div>
                    <div class="tbl_start">
                        <samp>{{"START" | translate}}</samp>
						<p>{{item.startTime}}</p>
                    </div>
                    <div class="tbl_finish">
                        <samp>{{"FINISH" | translate}}</samp>						

						<p>{{item.endTime}}</p>
                    </div>
                    <div class="tbl_break">
                        <samp>{{"BREAK" | translate}}</samp>
                        
						<p>{{item.breakMinutes}}</p>
                    </div>
                    <div class="tbl_mnBreak">
                        <samp>{{"MIDNIGHTBREAK" | translate}}</samp>
                        <p>{{item.midnightBreakMinutes}}</p>
                    </div>
                    <div class="tbl_note">
                        <samp>{{"NOTE" | translate}}</samp>                        
						<p>{{item.noteKey | translate}}</p>
                    </div>
                    <div class="tbl_home">
                        <samp>{{"HOME" | translate}}</samp>
                        <label class="switch2">
							<input type="checkbox" [(ngModel)]="item.whf" [ngModelOptions]="{standalone: true}" disabled="">
							<span class="slider"></span>
						</label>
                    </div>
                    <div class="tbl_exp">
                        <samp>{{"EXPENSES" | translate}}</samp>                        
						<p>{{item.expensesKey | translate}}</p>
                    </div>
                    <div class="tbl_amtExp">
                        <samp>{{"AMOUNTOFEXPENSES" | translate}}</samp>
                        <p>{{item.cost}}</p>
                    </div>
                    <div class="tbl_etc">
                        <samp>{{"ETC" | translate}}</samp>
						<span *ngIf="item.countEtcRemarks > 0" [ngClass]="'get_comment'" (click)="onRejectClick(item)">({{item.countEtcRemarks}})</span>
						<!-- <input type="text"  /> -->
						<p *ngIf="editingRow !== i" 
						class="info" 
						data-bs-toggle="tooltip" 
						data-bs-placement="top" 
						[attr.title]="item.etcRemarks || 'No remark'"
  						#tooltipEl>{{getShortText(item.etcRemarks, 25)}}</p>
                    </div>
                </article>
				<!-- 否認理由入力行 -->
				<div class="reject_remarks_row" *ngIf="editingRow === i">
					<label>{{'ETC' | translate}}:</label>
					<input type="text" class="form-control"
						[(ngModel)]="item.etcRemarks"
						[ngModelOptions]="{standalone: true}"
						placeholder="{{'ETC' | translate}}" />
					<div class="remarks-buttons">
						<button name="cancel" class="cancel" (click)="cancelReject(i)" title="{{'CLIENT_CANCEL_TOOLTIP' | translate}}">cancel</button>
						<button name="save" class="save" (click)="saveReject(i)" title="{{'CLIENT_SAVE_TOOLTIP' | translate}}">save</button>
					</div>
				</div>
            </section>
        </div>
		<!-- Table Heading End as loop -->
	</div>
	
	<!--  ############### Data Table End ################# -->
	<div class="work_hour_info">
		<h6>{{"Contract" | translate}} -</h6>
		<span *ngIf="jobOrderData">{{"START" | translate}} {{ toTimeString(jobOrderData.WorkStartTime) }}</span><span *ngIf="jobOrderData">{{"FINISH" | translate}} {{ toTimeString(jobOrderData.WorkEndTime) }}</span><span *ngIf="jobOrderData">{{"BREAK" | translate}} {{jobOrderData.breakTime}}</span><span *ngIf="jobOrderData">{{"MIDNIGHTBREAK" | translate}} {{jobOrderData.midBreakTime}}</span>
	</div>
	<div class="time_sheet_comment">
		<h3>{{"CommentsRemarks" | translate}}</h3>
		<textarea *ngIf="timeSheetCmnData" class="form-control" id="floatingTextarea2" [(ngModel)]="timeSheetCmnData.comments"
			(ngModelChange)="markCommentDirty()" style="height: 100px"></textarea>
	</div>
	<div class="actio_button_area">
		<button class="butn save_entry btn" (click)="onSaveComment()" [disabled]="!isCommentDirty || archive">{{"SAVE" | translate}}</button>
		<button class="butn cancel_entry btn" (click)="onCancelComment()" [disabled]="!isCommentDirty || archive">{{"CANCEL" | translate}}</button>
	</div>

	<div class="training_entry_box mt-3" *ngIf="historyCommentsDis !== ''">
		<h4>{{"ClienttimeSheet.ClaimHistory" | translate}}  
			<!-- {{"ClienttimeSheet.Claimeddate" | translate}}: {{formatClaimDate(timeSheetCmnData.complaintCmtUpdateDate)}} -->
		</h4>
		<p style="white-space: pre-line;">{{historyCommentsDis}}</p>
	</div>
	<div class="training_entry_box mt-3" *ngIf="trainingCommentsDis !== ''">
		<h4>{{"ClienttimeSheet.TrainingHistory" | translate}}</h4>
		<p style="white-space: pre-line;">{{trainingCommentsDis}}</p>
	</div>
	<!-- <div class="time_sheet_comment">
		<h3>{{"CommentsRemarks" | translate}}</h3>
		<textarea *ngIf="timeSheetCmnData" class="form-control" id="floatingTextarea2" [(ngModel)]="timeSheetCmnData.comments"
			style="height: 100px"></textarea>
	</div> -->
	<!-- <div class="actio_button_area">
		<button class="butn save_entry btn" (click)="onSave()">{{"SAVE" | translate}}</button>
		<button class="butn cancel_entry btn">{{"CANCEL" | translate}}</button>
		<button class="butn log_entry btn">{{"LOG" | translate}}</button> 
		 <a class="butn log_entry btn" href="associate-time-log/{{timesheetIdOrg}}">{{"LOG" | translate}}</a>
	</div> -->
	<!--  ############### Row 1 End ################# -->
	<!-- <div class="training_entry_box">
		<h4>{{"EducationTrainingRecords" | translate}}</h4>
		<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
			been the industry's standard dummy text ever since the 1500s, <a href="javascript: void(0)">{{"EducationTrainingRecords" | translate}}</a>
		</p>
	</div> -->
	<div class="actio_button_area">
		<button class="butn claim_history btn" data-bs-toggle="modal" data-bs-target="#claim_history_popup">{{"ClienttimeSheet.ClaimHistory" | translate}}</button>
		<button class="butn training_history btn" data-bs-toggle="modal" data-bs-target="#training_history_popup">{{"ClienttimeSheet.TrainingHistory" | translate}}</button>
	</div>
</div>

<!-- Modal for claim_history Start-->
	<div class="modal fade" id="claim_history_popup" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
		aria-labelledby="staticBackdropLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-scrollable custom_modal">
			<div class="modal-content">
				<div class="modal-header">
					<h3 class="modal-title">{{"ClienttimeSheet.ClaimHistory" | translate}} </h3>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="sub_header_block">
					<div class="col-auto">
						{{"ClaimHistoryHeading" | translate}}
					</div>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12">
							<textarea name="" id="" class="form-control" rows="3" placeholder="{{'TrainingCmntPlaceHolder' | translate}}" [(ngModel)]="historyComments"></textarea>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button #btnclaim_history_popup type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{"CLOSEBTN" | translate}}</button>
					<button type="button" class="btn btn-primary" (click)="saveHistory()">{{"SAVE" | translate}}</button>
				</div>
			</div>
		</div>
	</div>
	<!-- Modal for claim_history End-->

	<!-- Modal for training_history Start-->
	<div class="modal fade" id="training_history_popup" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
		aria-labelledby="staticBackdropLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-scrollable custom_modal">
			<div class="modal-content">
				<div class="modal-header">
					<h3 class="modal-title">{{"ClienttimeSheet.TrainingHistory" | translate}}</h3>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="sub_header_block">
					<div class="col-auto">
						{{"TrainingHistoryHeading" | translate}}
					</div>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12">
							<textarea name="" id="" class="form-control" rows="3" placeholder="{{'TrainingCmntPlaceHolder' | translate}}" [(ngModel)]="trainingComments" ></textarea>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button #btntraining_history_popup type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{"CLOSEBTN" | translate}}</button>
					<button type="button" class="btn btn-primary" (click)="saveTraining()">{{"SAVE" | translate}}</button>
				</div>
			</div>
		</div>
	</div>
	<!-- Modal for training_history End-->
<!--  ############### Middle Containt Area End ################# -->